import { computed, defineComponent, watch } from 'vue';
import { validationRequired } from '@/core/helpers/validation';
export default defineComponent({
    props: {
        answerTypeId: String,
        scheme: {
            type: Object,
            default: () => {
                return {};
            }
        },
        statementFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        competencyUnit: {
            type: Object,
            default: () => {
                return {};
            }
        },
        disabled: Boolean,
        isAssessment: Boolean,
        order: Number
    },
    emits: ['update:statementFields', 'triggerCompleted'],
    setup(props, { emit }) {
        const modelStatementFields = computed({
            get() {
                return props.statementFields;
            },
            set(value) {
                emit('update:statementFields', value);
            }
        });
        const competencyUnitRow = computed(() => {
            var _a;
            if (props.competencyUnit) {
                let row = [];
                (_a = props.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => {
                    return item.answerTypeId === props.scheme.answerTypeId;
                }).forEach((statement, statementIndex) => {
                    statement.details.forEach((detail, detailIndex) => {
                        row.push(Object.assign(Object.assign({}, statement), { statementIndex,
                            detailIndex }));
                    });
                });
                return row;
            }
            return [];
        });
        const foundIndex = (row, answerFieldId) => {
            const statementFields = modelStatementFields.value.findIndex((item) => {
                return item.statement.id === row.id;
            });
            const statementDetailAnswerFields = modelStatementFields.value[statementFields].statementDetailFields[row.detailIndex].statementDetailAnswerFields.findIndex((item) => {
                return item.formAnswerField.answerFieldId === answerFieldId;
            });
            return {
                statementFields,
                statementDetailAnswerFields
            };
        };
        const checkCompleted = computed(() => {
            var _a;
            if (!props.isAssessment)
                return false;
            if (competencyUnitRow.value.length &&
                props.competencyUnit.customAnswerFields.length) {
                return (_a = competencyUnitRow.value) === null || _a === void 0 ? void 0 : _a.filter((item) => {
                    return item.answerTypeId === props.answerTypeId;
                }).map((statement) => {
                    var _a;
                    return (_a = props.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => {
                        return item.answerType.id === props.answerTypeId;
                    }).map((customAnswerField) => {
                        if (customAnswerField.answerField.type !== 'radio') {
                            return true;
                        }
                        if (modelStatementFields.value[foundIndex(statement, customAnswerField.answerField.id)
                            .statementFields].statementDetailFields[statement.detailIndex]
                            .statementDetailAnswerFields[foundIndex(statement, customAnswerField.answerField.id)
                            .statementDetailAnswerFields].value) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                }).every((parent) => {
                    return parent.every((child) => {
                        return child;
                    });
                });
            }
            return false;
        });
        watch(() => {
            return checkCompleted.value;
        }, (newValue) => {
            emit('triggerCompleted', newValue);
        }, { immediate: true, deep: true });
        return {
            validationRequired,
            modelStatementFields,
            competencyUnitRow,
            foundIndex
        };
    }
});
